import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { config } from '../../../../../../config';

const apiClientConfig: ApiClientConfig = {
  timeout: config.portfolioLoansSummary.requestTimeout
};
const portfolioLoansTimeout: number = config.portfolioLoansSummary.requestTimeout;
const masterPoolDataSet: string = config.dataSetApi.urls.dataset;

export const getMasterpoolsDataSet = async (
  authenticationContext: any,
  masterPoolCmhcAccountNumber: string
): Promise<Blob | null> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      `${masterPoolDataSet}/master-pools/${masterPoolCmhcAccountNumber}/datasets/report`,
      {
        responseType: 'blob',
        timeout: portfolioLoansTimeout
      }
    );

    if (
      response.status === HttpResponseStatusCodes.OK ||
      response.status === HttpResponseStatusCodes.Created
    ) {
      return response.data;
    }

    return null;
  } catch (err) {
    console.error('Error fetching dataset:', err);
    throw err;
  }
};
